(function(){

    'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

    function pxWebhookDirective(
    $timeout, $filter, toastr, $http, WebhookService, WEBHOOK_EVENTS,
    $rootScope
    ) {
    return {
        restrict: 'EA',
        scope: {
        context: '=context',
        tenant: '=tenant',
        state: '=state',
        meta: '=meta',
        callback: '&callback'
        },
        templateUrl: 'app/components/applications/webhook/webhook.template.html',
        link: function(scope) {

            function WebhookFormModel () {
                this.url              = '';
                this.subscribedEvents =[];
            }

            scope.SECRET_ROTATION = '';
            scope.webhookEvents   = angular.copy(WEBHOOK_EVENTS);
            scope.TEST_COMPLETE   = false;
            var webhookOriginal   = null;


            (function() {
                setState(scope.state)
            })();
            
            function setState (state){
                switch (state) {
                    case 'CREATE':
                        scope.webhook = {
                            info: new WebhookFormModel()
                        }
                        scope.invalidURL      = false;
                        scope.badURL          = false;
                        scope.formInvalid     = true;
                    break;
                    case 'MODIFY':
                        scope.webhook   = angular.copy(scope.context.data);
                        webhookOriginal = angular.copy(scope.webhook);
                        scope.webhook.info.subscribedEvents.forEach(eventType => {
                            scope.webhookEvents[eventType] = true;
                        })
                    break;
                    case 'TEST_WEBHOOK':
                        var url = scope.context.data.info._links['px:testWebhook'].href;
                        scope.webhook = angular.copy(scope.context.data);
                        testWebhook(url);
                    break;
                    case 'CREATE_SECRET':
                        scope.webhook = angular.copy(scope.context.data);
                    break;
                    
                }
            }

            scope.validateForm = () => {
                if (!scope.webhook.info.url || scope.webhook.info.subscribedEvents.length === 0) {
                    scope.formInvalid = true;
                } else {
                    scope.formInvalid = false;
                }
            }

            scope.updateEvents = () => {
                Object.keys(scope.webhookEvents)
                    .filter(eventType  => scope.webhookEvents[eventType] && !scope.webhook.info.subscribedEvents.includes(eventType))
                    .forEach(eventType => scope.webhook.info.subscribedEvents.push(eventType));
                scope.webhook.info.subscribedEvents = scope.webhook.info.subscribedEvents.filter(eventType => scope.webhookEvents[eventType]);
                scope.validateForm();
            }
            

            ////////////////////////////////////////////
            // CRUD's
            ////////////////////////////////////////////
            scope.create = () => {
                WebhookService.create(scope.webhook.info).then(() => {
                    scope.callback();
                    var message = $filter("translate")("Created") + ': ' + scope.webhook.info.url;
                    toastr.success(message);

                    $rootScope.$broadcast('WEBHOOK_RELOAD_PAGE');
                }).catch((error) => {
                    scope.callback();
                    switch (error.data.errorCode){
                        case 'VALIDATION_FAILED':
                            error.data.errorCode              = error.data.errorText.replace('.', ', ') + error.data.fieldErrors[0].defaultMessage + '.';
                            error.data.parameterizedErrorText = error.data.errorText.replace('.', ', ') + error.data.fieldErrors[0].defaultMessage + '.';
                            $rootScope.$broadcast('REQUEST_ERROR_HELP', {error: error})
                        break;
                        default:
                            $rootScope.$broadcast('REQUEST_ERROR_HELP', {error: error})
                    }
                });
            }

            scope.update = () => {
                scope.webhook.update(webhookOriginal, scope.webhook).then(() => {
                    toastr.success('ChangesSaved');
                    scope.callback();
                }).catch((error) => {
                    console.log('error', error);
                    scope.callback();
                })
            }

            scope.rotateSecret = (link) => {
                var delay = 1000;
                if (!scope.SECRET_ROTATION) {
                    scope.SECRET_ROTATION = link;
                    $timeout(() => {
                        scope.webhook.rotateSecret(link).then((webhook) => {
                            $timeout(() => {
                                $rootScope.$broadcast('WEBHOOK_RELOAD_PAGE');
                                scope.webhook = webhook;
                                scope.SECRET_ROTATION = '';
                            }, delay);
                        }).catch((error) => {
                            
                        });
                    }, delay);
                } else {
                    return
                }
            }

            ////////////////////////////////////////////
            // Test Webhook
            ////////////////////////////////////////////
            function testWebhook(url) {
                $http.post(url).then((response) => {
                    scope.testResult = response.data;
                    scope.TEST_COMPLETE = true;
                }).catch((error) => {

                });
            }

            ////////////////////////////////////////////
            // Copy to clipboard
            ////////////////////////////////////////////
            scope.copyData = (stringData) => {
                if (!scope.SECRET_ROTATION) {
                    var data = stringData.split(' ')[0];
                    var input = document.createElement('input');
                    input.setAttribute('value', data);
                    document.body.appendChild(input);
                    input.select();
                    document.execCommand('copy');
                    document.body.removeChild(input)
                    var message = $filter("translate")("CopyToClipboard")
                    
                    toastr.success(`${message}: ${data}`);
                }
            }

            scope.markAll = (event) => {
                console.log('event', event);
                if (!scope.SECRET_ROTATION) {
                    console.log('event', event);
                    
                    var range = document.createRange();
                    range.selectNodeContents(event.currentTarget);
                    var selection = window.getSelection();
                    selection.removeAllRanges();
                    selection.addRange(range);
                }
            };

            scope.$on('$destroy', function() {
                scope.webhook = null;
            });

        }
    };
    }

    pxWebhookDirective.$inject = [
        '$timeout', '$filter', 'toastr', '$http', 'WebhookService', 'WEBHOOK_EVENTS',
        '$rootScope'
    ];

    angular
    .module('printix-admin')
    .directive('pxWebhookDirective', pxWebhookDirective)
    .constant('WEBHOOK_EVENTS', {
        'RESOURCE.TENANT_USER.CREATE': false
    });

})();
